import React, { useState } from 'react';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import { hasRoleAdmin } from 'common/userRoles';

import useDispatch from 'client/hooks/useDispatch';
import useBranch from 'client/hooks/useBranch';

import SrCard, { SR_CARD_BULLET_COLOR_BLUE } from 'client/components/SrCard/SrCard';
import SrModalV2, { MODAL_THEME_STACK } from 'client/components/SrModalV2/SrModalV2';
import SrTag, {
  SR_TAG_THEME_LIGHTBLUE_BLACK,
  SR_TAG_THEME_LIGHTBLUE_BLACK_HOVER,
  SR_TAG_THEME_WHITE_BLACK,
} from 'client/components/SrTag/SrTag';
import SrAdminListingNotes from 'client/components/SrAdminListingNotes';

const SrListingNotesChip = ({ listingId, notesCount, onModalClose }) => {
  const { currentUser } = useBranch({
    currentUser: ['currentUser'],
  });
  const dispatch = useDispatch();
  const [listingNotesModal, setListingNotesModal] = useState(null);
  const isAdmin = hasRoleAdmin(currentUser.roles);
  const onNoteClick = (event) => {
    event.preventDefault();

    setListingNotesModal(listingId);
  };
  const onCloseNotesModal = async () => {
    if (onModalClose) {
      await onModalClose();
    }
    setListingNotesModal(null);
  };
  const hasNotes = notesCount > 0;
  const blueTheme = isAdmin ? SR_TAG_THEME_LIGHTBLUE_BLACK_HOVER : SR_TAG_THEME_LIGHTBLUE_BLACK;

  const theme = hasNotes ? blueTheme : SR_TAG_THEME_WHITE_BLACK;

  const onTagClick = isAdmin ? (e) => onNoteClick(e) : undefined;

  return (
    <>
      <SrTag theme={theme} variation="goingToMarketCard" onClick={onTagClick}>
        {`${pluralize('Note', notesCount, true)}`}
      </SrTag>
      {listingNotesModal && (
        <SrModalV2
          closeOnBackgroundClick
          showCloseButton={false}
          contentMaxWidth="546px"
          contentPadding="0px"
          theme={MODAL_THEME_STACK}
          onClose={onCloseNotesModal}
        >
          <SrCard header="Notes (Admin-Only)" color={SR_CARD_BULLET_COLOR_BLUE} maxWidth="none">
            <SrAdminListingNotes
              listingId={listingId}
              dispatch={dispatch}
              currentUser={currentUser}
            />
          </SrCard>
        </SrModalV2>
      )}
    </>
  );
};

SrListingNotesChip.propTypes = {
  listingId: PropTypes.number.isRequired,
  notesCount: PropTypes.number.isRequired,
  onModalClose: PropTypes.func,
};

SrListingNotesChip.displayName = 'SrListingNotesChip';

export default SrListingNotesChip;
